import { jsx as _jsx } from "react/jsx-runtime";
export const DiscussionVersionNumber = (param)=>{
    let { onVersionClick, discussionVersion } = param;
    const versionText = "V".concat(discussionVersion);
    if (!discussionVersion) {
        return null;
    }
    return !onVersionClick ? /*#__PURE__*/ _jsx("div", {
        className: "text-12 text-grey-10",
        children: versionText
    }) : /*#__PURE__*/ _jsx("button", {
        className: "text-12 text-grey-10 hover:underline",
        onClick: onVersionClick,
        children: versionText
    });
};
